import type { IconData } from '@stacksjs/iconify-core'

export const natureSea: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 3a5 5 0 0 0 4-2a5 5 0 0 0 4 2a5 5 0 0 0 4-2a5 5 0 0 0 4 2v5a5 5 0 0 1-4-2a5 5 0 0 1-4 2a5 5 0 0 1-4-2a5 5 0 0 1-4 2zm4 5a5 5 0 0 1-4 2v5c1.457 0 2.823-.39 4-1.07C5.177 14.61 6.543 15 8 15s2.823-.39 4-1.07A7.96 7.96 0 0 0 16 15v-5a5 5 0 0 1-4-2a5 5 0 0 1-4 2a5 5 0 0 1-4-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureSea
